/**
 * Concept Actions
 */
export const CONCEPTS_ACTIONS = {
	// GET: creativelibraries/{libraryId}/concepts (Get list of concepts)
	FETCH_ALL_CONCEPTS_AJAX:		"FETCH_ALL_CONCEPTS_AJAX",
	FETCH_ALL_CONCEPTS_SUCCESS:		"FETCH_ALL_CONCEPTS_SUCCESS",
	FETCH_ALL_CONCEPTS_ERROR:		"FETCH_ALL_CONCEPTS_ERROR",
	// GET: creative-libraries/${libraryId}/concepts?advancedFilter=all(eq(conceptName,${conceptName}),eq(conceptType,${conceptType})) (Get single named Concept)
	FETCH_CONCEPT_BY_NAME_AND_TYPE:		"FETCH_CONCEPT_BY_NAME_AND_TYPE",
	FETCH_CONCEPT_BY_NAME_AND_TYPE_SUCCESS:		"FETCH_CONCEPT_BY_NAME_AND_TYPE_SUCCESS",
	FETCH_CONCEPT_BY_NAME_AND_TYPE_ERROR:		"FETCH_CONCEPT_BY_NAME_AND_TYPE_ERROR",
	// PUT: creativelibraries/{libraryId}/concepts/{conceptId} (Update concept)
	RENAME_CONCEPT_AJAX:			"RENAME_CONCEPT_AJAX",
	RENAME_CONCEPT_SUCCESS:			"RENAME_CONCEPT_SUCCESS",
	RENAME_CONCEPT_ERROR:			"RENAME_CONCEPT_ERROR",
	// DELETE: creative-libraries/{libraryId}/concepts/{conceptId} (Delete concept)
	DELETE_CONCEPT_AJAX					:"DELETE_CONCEPT_AJAX",
	DELETE_CONCEPT_SUCCESS				:"DELETE_CONCEPT_SUCCESS",
	DELETE_CONCEPT_ERROR				:"DELETE_CONCEPT_ERROR",
	//POST: creative-libraries/{libraryId}/concepts/{conceptId} (Duplicate concept)
	DUPLICATE_CONCEPT_AJAX				:"DUPLICATE_CONCEPT_AJAX",
	DUPLICATE_CONCEPT_SUCCESS			:"DUPLICATE_CONCEPT_SUCCESS",
	DUPLICATE_CONCEPT_ERROR				:"DUPLICATE_CONCEPT_ERROR",
	// GET:  concepts/{conceptID}/creatives (Fetch Creatives By Concept Id)
	FETCH_CREATIVES_BY_CONCEPT_AJAX		:"FETCH_CREATIVES_BY_CONCEPT_AJAX",
	FETCH_CREATIVES_BY_CONCEPT_SUCCESS	:"FETCH_CREATIVES_BY_CONCEPT_SUCCESS",
	FETCH_CREATIVES_BY_CONCEPT_ERROR	:"FETCH_CREATIVES_BY_CONCEPT_ERROR",

	// Concept Saving
	SAVE_CONCEPT_AJAX					:"SAVE_CONCEPT_AJAX",
	SAVE_CONCEPT_SUCCESS				:"SAVE_CONCEPT_SUCCESS",
	SAVE_CONCEPT_ERROR					:"SAVE_CONCEPT_ERROR",
};

export const CONCEPT_DETAIL_ACTIONS = {
	CLEAR_CONCEPT_DETAILS:"CLEAR_CONCEPT_DETAILS",

	LOAD_CONCEPT_AJAX: "LOAD_CONCEPT_AJAX",
	LOAD_CONCEPT_SUCCESS: "LOAD_CONCEPT_SUCCESS",
	LOAD_CREATIVE_ERROR: "LOAD_CREATIVE_ERROR",

	SAVE_SOCIAL_CONCEPT_AJAX:"SAVE_SOCIAL_CONCEPT_AJAX",
	SAVE_SOCIAL_CONCEPT_SUCCESS:"SAVE_SOCIAL_CONCEPT_SUCCESS",
	SAVE_SOCIAL_CONCEPT_ERROR:"SAVE_SOCIAL_CONCEPT_ERROR",

	SAVE_NEW_SOCIAL_CONCEPT_AJAX:"SAVE_NEW_SOCIAL_CONCEPT_AJAX",
	SAVE_NEW_SOCIAL_CONCEPT_SUCCESS:"SAVE_NEW_SOCIAL_CONCEPT_SUCCESS",
	SAVE_NEW_SOCIAL_CONCEPT_ERROR:"SAVE_NEW_SOCIAL_CONCEPT_ERROR",
	SAVE_ADD_TO_SOCIAL_CONCEPT_SUCCESS:"SAVE_ADD_TO_SOCIAL_CONCEPT_SUCCESS",

	SAVE_NEW_SOCIAL_CONCEPT2_AJAX:"SAVE_NEW_SOCIAL_CONCEPT2_AJAX",
	SAVE_NEW_SOCIAL_CONCEPT2_SUCCESS:"SAVE_NEW_SOCIAL_CONCEPT2_SUCCESS",
	SAVE_NEW_SOCIAL_CONCEPT2_ERROR:"SAVE_NEW_SOCIAL_CONCEPT2_ERROR",

	ADD_CREATIVE_TO_SOCIAL_CONCEPT2_AJAX: "ADD_CREATIVE_TO_SOCIAL_CONCEPT2_AJAX",
	ADD_CREATIVE_TO_SOCIAL_CONCEPT2_SUCCESS:"ADD_CREATIVE_TO_SOCIAL_CONCEPT2_SUCCESS",
	ADD_CREATIVE_TO_SOCIAL_CONCEPT2_ERROR:"ADD_CREATIVE_TO_SOCIAL_CONCEPT2_ERROR",

	SAVE_CONCEPT_AJAX:"SAVE_CONCEPT_AJAX",
	SAVE_CONCEPT_SUCCESS:"SAVE_CONCEPT_SUCCESS",
	SAVE_CONCEPT_ERROR:"SAVE_CONCEPT_ERROR",

	//PUT:	creative-libraries/{libraryId}/concepts/{conceptId} (Add Existing Creatives to Concept)
	ADD_EXISTING_CREATIVES_TO_CONCEPT:"ADD_EXISTING_CREATIVES_TO_CONCEPT",
	ADD_EXISTING_CREATIVES_TO_CONCEPT_SUCCESS:"ADD_EXISTING_CREATIVES_TO_CONCEPT_SUCCESS",
	ADD_EXISTING_CREATIVES_TO_CONCEPT_ERROR:"ADD_EXISTING_CREATIVES_TO_CONCEPT_ERROR",

	REMOVE_CREATIVES_FROM_CONCEPT_AJAX:"REMOVE_CREATIVES_FROM_CONCEPT_AJAX",
	REMOVE_CREATIVES_FROM_CONCEPT_SUCCESS:"REMOVE_CREATIVES_FROM_CONCEPT_SUCCESS",
	REMOVE_CREATIVES_FROM_CONCEPT_ERROR:"REMOVE_CREATIVES_FROM_CONCEPT_ERROR",

	UPDATE_DISPLAY_HTML_TAG_AJAX: "UPDATE_DISPLAY_HTML_TAG_AJAX",
	UPDATE_DISPLAY_HTML_TAG_SUCCESS: "UPDATE_DISPLAY_HTML_TAG_SUCCESS",
	UPDATE_DISPLAY_HTML_TAG_ERROR: "UPDATE_DISPLAY_HTML_TAG_ERROR",

	ADD_NEW_DISPLAY_HTML_TAGS_TO_CONCEPT_AJAX: "ADD_NEW_DISPLAY_HTML_TAGS_TO_CONCEPT_AJAX",
	ADD_NEW_DISPLAY_HTML_TAGS_TO_CONCEPT_SUCCESS: "ADD_NEW_DISPLAY_HTML_TAGS_TO_CONCEPT_SUCCESS",
	ADD_NEW_DISPLAY_HTML_TAGS_TO_CONCEPT_ERROR: "ADD_NEW_DISPLAY_HTML_TAGS_TO_CONCEPT_ERROR",
};
